
// it defines the fields to show in the detail screen


export const fieldDetails = {
  person: {
    fields: [
      {
        property: 'biography',
        avatar: true
      },
      'searchName',
      'firstName',
      'middleName',
      'lastName',
      'professionalName',
      'pseudonym',
      'firstNameInternational',
      'nickNameInternational',
      'middleNameInternational',
      'lastNameInternational',
      {
        property: 'Prefix.name',
        label: 'Prefix'
      },
      {
        property: 'PrefixInternational.name',
        label: 'Prefix International'
      },

      {
        property: 'Suffix.name',
        label: 'Suffix'
      },
      {
        property: 'SuffixInternational.name',
        label: 'Suffix International'
      },
      
      'philosophy',
      'quote',
      'interests',
      'trivia',
      'comment',
      'aspiringTo',
      'education',
      'industryFigure',
      'publicFigure',
      {
        property: 'Nationality',
        type: 'tree',
        keepOrder: true,
      },
      {
        property: 'NationalityAtBirth',
        type: 'tree',
        keepOrder: true,
        label: 'Nationality at birth'
      },
      {
        property: 'dateOfBirth',
        type: 'date'
      },
      {
        property: 'PlaceOfBirth',
        type: 'tree',
        keepOrder: true,
      },
      {
        property: 'GroupIdentity',
        type: 'localized'
      },
      {
        property: 'SexualOrientation',
        type: 'localized'
      },
      {
        property: 'Gender',
        type: 'localized'
      },
      {
        property: 'Sex',
        type: 'localized'
      },
      'deceased',
      {
        property: 'dateDeceased',
        type: 'date'
      },
      'contactViaPersonalAssistant',


    ],
  },
  film: {
    fields: [
      'hidden',
      {
        property: 'filmName',
        label: 'Name',
      },
      {
        property: 'localFilmName',
        label: 'Local Name',
      },
      'headline',
      'internationalHeadline',
      'synopsis',
      'synopsisAuthor',
      'productionComment',
      {
        property: 'releaseDate',
        type: 'date',
      },
      'budgetCurrency',
      'budget',
      {
        property: 'AdID',
        label: 'AdID',
      },
      {
        property: 'ISAN',
        label: 'ISAN',
      },
      {
        property: 'UPC',
        label: 'UPC',
      },
      {
        property: 'ISRC',
        label: 'ISRC',
      },
      {
        property: 'Location',
        type: 'tree',
        keepOrder: true,
      },
      {
        property: 'OperationRegion',
        type: 'localized',
      },
      {
        property: 'CritiqueRating',
        type: 'localized',
      },
      {
        property: 'FilmCommissionType',
        type: 'localized',
      },
    ],
  },
  brand: {
    fields: [
      {
        property: 'name',
        avatar: true,
      },
      'strategy',
      {
        property: 'url',
        type: 'url',
        label: 'website',
      },
      {
        property: 'ProductCategory',
        type: 'treeLocalized',
      },
      {
        property: 'BrandToSlogans.slogan',
        label: 'Slogan(s)'
      }
    ],
  },
  award: {
    fields: [
      {
        label: 'Name',
        property: 'AwardLocalized.name',
        avatar: true,
      },
    ],
  },
  company: {
    fields: [
      {
        property: 'CompanyNames.name',
        avatar: true,
        label: 'Name(s)'
      },
      'missionStatement',
      'details',
      'experience',
      {
        property: 'url',
        type: 'url',
        label: 'Website',
      },
      {
        property: 'CompanyToCompanyTypes.CompanyType',
        type: 'treeLocalized',
        label: 'Company type',
      },
      'numberofEmployees',
      'independent',
      {
        property: 'foundedDate',
        type: 'date'
      },
      'ceasedTrading',
      {
        property: 'ceasedTradingDate',
        type: 'date'
      },

    ],
  },


  product: {
    fields: [
      {
        property: 'name',
        avatar: true,
      },
      {
        property: 'ProductCategory',
        type: 'treeLocalized',
      },
      {
        property: 'url',
        type: 'url',
        label: 'website',
      }, 
      {
        property: 'ProductToSlogans.slogan',
        label: 'Slogan(s)'
      }
    ],
  },
};
